/** Format currency for display: show decimals only when non-zero (max 2 dp), truncate — do not round. */
export const formatMoneyDisplay = (amount: number): string => {
  const sign = amount < 0 ? '-' : '';
  const cents = Math.trunc(Math.abs(amount) * 100);
  const wholePart = Math.trunc(cents / 100);
  const fracPart = cents % 100;
  if (fracPart === 0) {
    return `${sign}$${wholePart}`;
  }
  const fracText =
    fracPart % 10 === 0
      ? String(Math.trunc(fracPart / 10))
      : fracPart < 10
        ? `0${fracPart}`
        : String(fracPart);
  return `${sign}$${wholePart}.${fracText}`;
};
